import clamp from "lodash/clamp";
import type { CSSProperties } from "react";

import { FLOATING_EXPANDABLE_BUBBLE_MARGIN } from "../constants";
import type { BubblePosition } from "../types";
import { getBubbleAnchorStyle } from "./get_bubble_anchor_style";

type Size = { width: number; height: number };
type Viewport = { width: number; height: number };

export const getOpenBoxAnchorStyle = (
  position: BubblePosition,
  halfBubble: number,
  viewport: Viewport,
  panelSize: Size,
  margin: number = FLOATING_EXPANDABLE_BUBBLE_MARGIN
): CSSProperties => {
  const base = getBubbleAnchorStyle(position, halfBubble);
  const { vertical } = position;

  if (vertical.type !== "fraction") {
    return base;
  }

  const centerY = vertical.value * viewport.height;
  const bubbleTop = centerY - halfBubble;
  const bubbleBottom = centerY + halfBubble;

  const fitsBelow = bubbleTop + panelSize.height <= viewport.height - margin;
  if (fitsBelow) {
    return base;
  }

  const { top: _unusedTop, ...horizontal } = base;
  const maxBottom = Math.max(margin, viewport.height - panelSize.height - margin);
  const bottom = clamp(viewport.height - bubbleBottom, margin, maxBottom);

  return { ...horizontal, bottom };
};
